var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("header", { staticStyle: { "padding-bottom": "20px" } }, [
    _c("table", { staticStyle: { width: "100%", "font-size": "18px" } }, [
      _c("tbody", [
        _c("tr", [
          _c("td", { staticStyle: { width: "35%", "text-align": "right" } }, [
            _c(
              "div",
              {
                staticStyle: { "font-weight": "bold", "margin-bottom": "5px" },
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.systemSettings.system_name_ar ||
                        _vm.Lang.get("messages.site_name_ar")
                    ) +
                    "\n          "
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticStyle: { "font-size": "14px" } }, [
              _vm.systemSettings.address
                ? _c("p", { staticStyle: { margin: "2px 0" } }, [
                    _vm._v(
                      _vm._s(_vm.Lang.get("messages.address")) +
                        ": " +
                        _vm._s(_vm.systemSettings.address)
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.systemSettings.phone
                ? _c("p", { staticStyle: { margin: "2px 0" } }, [
                    _vm._v(
                      _vm._s(_vm.Lang.get("messages.phone")) +
                        ": " +
                        _vm._s(_vm.systemSettings.phone)
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.systemSettings.email
                ? _c("p", { staticStyle: { margin: "2px 0" } }, [
                    _vm._v(
                      _vm._s(_vm.Lang.get("messages.email")) +
                        ": " +
                        _vm._s(_vm.systemSettings.email)
                    ),
                  ])
                : _vm._e(),
            ]),
          ]),
          _vm._v(" "),
          _c("td", { staticStyle: { "text-align": "center" } }, [
            _c("img", {
              staticStyle: { height: "100px" },
              attrs: {
                src:
                  _vm.systemSettings.system_logo_url || "/images/schoolna.png",
                alt: "System Logo",
              },
            }),
          ]),
          _vm._v(" "),
          _c("td", { staticStyle: { width: "35%", "text-align": "left" } }, [
            _c(
              "div",
              {
                staticStyle: { "font-weight": "bold", "margin-bottom": "5px" },
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.systemSettings.system_name_en ||
                        _vm.Lang.get("messages.site_name_en")
                    ) +
                    "\n          "
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticStyle: { "font-size": "14px" } }, [
              _vm.systemSettings.address
                ? _c("p", { staticStyle: { margin: "2px 0" } }, [
                    _vm._v("Address: " + _vm._s(_vm.systemSettings.address)),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.systemSettings.phone
                ? _c("p", { staticStyle: { margin: "2px 0" } }, [
                    _vm._v("Phone: " + _vm._s(_vm.systemSettings.phone)),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.systemSettings.email
                ? _c("p", { staticStyle: { margin: "2px 0" } }, [
                    _vm._v("Email: " + _vm._s(_vm.systemSettings.email)),
                  ])
                : _vm._e(),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }